import Angular from "angular";
import Controller from "./chart-booking-workload.controller";
import Template from "./chart-booking-workload.html";
import Duration from "../../../core/components/duration/duration";

export default Angular.module('chart-booking-workload', [Duration.name])
    .component('chartBookingWorkload', {
        template: Template,
        controller: Controller,
        bindings: {
            workload: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-workload/chart-booking-workload.js